import { scroller } from 'react-scroll'

export function scrollToTop (id = 'root', options = { smooth: true, duration: 500 }) {
  scroller.scrollTo(id, options)
}
